import axios from 'axios'

export default {
  namespaced: true,
  state: {
    user: null,
    utilisateur: null,
  },
  mutations: {
    SET_USER_DATA(state, userData) {
      state.user = userData
      let auth = {
        authenticationResponse: userData,
        utilisateurCourant: undefined,
      }
      localStorage.setItem('auth', JSON.stringify(auth))
      axios.defaults.headers.common['Authorization'] = `${userData.tokenType} ${userData.accessToken}`
    },
    SET_UTILISATEUR(state, _utilisateur) {
      state.utilisateur = _utilisateur
    },
    CLEAR_USER_DATA() {
      axios.defaults.headers.common['Authorization'] = ``
      localStorage.clear()
      location.reload()
    },
  },
  actions: {
    login({ dispatch, commit }, credentials) {
      return axios
        .post(`${process.env.VUE_APP_URL_BACK_SERENITY}/authentification/connexion`, credentials)
        .then(({ data }) => {
          commit('SET_USER_DATA', data)
          dispatch('fetchUtilisateurCourant', data.username)
        })
    },
    retrieveTokenFromStorage({ dispatch, commit }) {
      const userString = localStorage.getItem('auth')
      if (userString) {
        const auth = JSON.parse(userString)
        if (auth.authenticationResponse) {
          commit('SET_USER_DATA', auth.authenticationResponse)
          dispatch('fetchUtilisateurCourant', auth.authenticationResponse.username)
        }
      }
    },
    fetchUtilisateurCourant({ commit }, _email) {
      return axios
        .get(`${process.env.VUE_APP_URL_BACK_SERENITY}/utilisateur/email?_search=${_email}`)
        .catch((error) => {
          console.log(error)
        })
        .then((response) => {
          commit('SET_UTILISATEUR', response.data)
          this.dispatch('etablissement/fetchEtablissements')
          this.dispatch('etablissement/fetchAssociations')
        })
    },
    logout({ commit }) {
      console.log('vuex/security/logout')
      commit('CLEAR_USER_DATA')
    },
  },
  getters: {
    authenticated(state) {
      return !!state.user
    },
    isAdmin(state) {
      return state.user.roles.includes('ROLE_Administrateur')
    },
    isInRole: (state) => (_role) => {
      return (
        state.user &&
        (state.user.username === _role ||
          state.user.roles.includes('ROLE_' + _role) ||
          state.user.roles.includes('ROLE_Administrateur'))
      )
    },
    isInRoleSansBypassAdmin: (state) => (_role) => {
      return state.user && (state.user.username === _role || state.user.roles.includes('ROLE_' + _role))
    },
    getAuthenticatedUser(state) {
      return state.user
    },
    getUtilisateur(state) {
      return state.utilisateur
    },
  },
}
